import CapitalContents from '@di-shared/features/capital/CapitalContents';
import PublicServiceContents from '@di-shared/features/public-service/PublicServiceContents';

export interface FinanceContentsProps {
  vin: string;
}

function FinanceContents({vin}: FinanceContentsProps): JSX.Element {
  return (
    <div className="tab_content car_maintenance">
      <CapitalContents
        vin={vin}
        isProduction={true}
      />
      <PublicServiceContents vin={vin} />
    </div>
  );
}

export default FinanceContents;
